import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import { AccessTimeRounded } from "@mui/icons-material";
import { UserAuthCard, UserAuthShell } from "./user-auth-layout";

const AuthExpired = () => (
  <UserAuthShell maxWidth={460}>
    <UserAuthCard contentSx={{ p: { xs: 3.5, sm: 5 } }}>
      <Stack spacing={2.25} alignItems="center" textAlign="center">
        <Box
          sx={{
            width: 72,
            height: 72,
            display: "grid",
            placeItems: "center",
            borderRadius: "50%",
            color: "#a36c22",
            bgcolor: "#fff5df",
            border: "1px solid #f2dfb8",
          }}
        >
          <AccessTimeRounded sx={{ fontSize: 38 }} />
        </Box>

        <Box>
          <Typography
            component="h1"
            sx={{
              color: "#253940",
              fontSize: { xs: 28, sm: 32 },
              fontWeight: 700,
              letterSpacing: "-0.035em",
            }}
          >
            Session expired
          </Typography>
          <Typography sx={{ mt: 1, color: "#71838b", lineHeight: 1.65 }}>
            For your security, this sign-in request is no longer active. Return
            to the application and start a new sign-in.
          </Typography>
        </Box>
      </Stack>
    </UserAuthCard>
  </UserAuthShell>
);

export default AuthExpired;
